var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasPageQuiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 226,
    viewBox: "0 0 178 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_727_9946)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 160,
    height: 208,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 6.5,
    width: 159,
    height: 207,
    rx: 5.5,
    stroke: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.5 11V10.9979C168.495 9.69855 167.774 8.56446 166.695 7.77225C165.616 6.97982 164.15 6.50364 162.553 6.5H162.552L15.4483 6.5L15.4471 6.5C13.8498 6.50364 12.3843 6.97982 11.3049 7.77225C10.2259 8.56447 9.50549 9.69856 9.5 10.9979H9.5V11V23V23.5H10H168H168.5V23V11Z",
    fill: "#E5E8F5",
    stroke: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12.2402H24V18.4802H18V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 12.2402H34V18.4802H28V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 12.2402H44V18.4802H38V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 12.2402H113V18.4802H58V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 43,
    width: 122,
    height: 8,
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 54,
    width: 106,
    height: 8,
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 67,
    width: 122,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 93,
    width: 106,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 93,
    width: 13.4146,
    height: 13.4146,
    fill: "#2E4DCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 114,
    width: 13.4146,
    height: 13.4146,
    fill: "#EDF0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 135,
    width: 13.4146,
    height: 13.4146,
    fill: "#EDF0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 80,
    width: 106,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 114,
    width: 106,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 135,
    width: 106,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 159,
    width: 122,
    height: 22,
    rx: 4,
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1953 174V166H59.3516C59.9557 166 60.4714 166.108 60.8984 166.324C61.3281 166.538 61.6549 166.841 61.8789 167.234C62.1055 167.625 62.2188 168.085 62.2188 168.613C62.2188 169.145 62.1042 169.602 61.875 169.984C61.6458 170.365 61.3138 170.656 60.8789 170.859C60.4466 171.062 59.9232 171.164 59.3086 171.164H57.1953V169.805H59.0352C59.3581 169.805 59.6263 169.76 59.8398 169.672C60.0534 169.583 60.2122 169.451 60.3164 169.273C60.4232 169.096 60.4766 168.876 60.4766 168.613C60.4766 168.348 60.4232 168.124 60.3164 167.941C60.2122 167.759 60.0521 167.621 59.8359 167.527C59.6224 167.431 59.3529 167.383 59.0273 167.383H57.8867V174H56.1953ZM60.5156 170.359L62.5039 174H60.6367L58.6914 170.359H60.5156ZM63.4141 174V166H68.8047V167.395H65.1055V169.301H68.5273V170.695H65.1055V172.605H68.8203V174H63.4141ZM74.4893 168.301C74.458 167.986 74.3239 167.741 74.0869 167.566C73.8499 167.392 73.5283 167.305 73.1221 167.305C72.846 167.305 72.613 167.344 72.4229 167.422C72.2327 167.497 72.0869 167.603 71.9854 167.738C71.8864 167.874 71.8369 168.027 71.8369 168.199C71.8317 168.342 71.8617 168.467 71.9268 168.574C71.9945 168.681 72.0869 168.773 72.2041 168.852C72.3213 168.927 72.4567 168.993 72.6104 169.051C72.764 169.105 72.9281 169.152 73.1025 169.191L73.8213 169.363C74.1702 169.441 74.4906 169.546 74.7822 169.676C75.0739 169.806 75.3265 169.966 75.54 170.156C75.7536 170.346 75.9189 170.57 76.0361 170.828C76.1559 171.086 76.2171 171.382 76.2197 171.715C76.2171 172.204 76.0921 172.629 75.8447 172.988C75.5999 173.345 75.2458 173.622 74.7822 173.82C74.3213 174.016 73.7653 174.113 73.1143 174.113C72.4684 174.113 71.9059 174.014 71.4268 173.816C70.9502 173.618 70.5778 173.326 70.3096 172.937C70.0439 172.547 69.9046 172.064 69.8916 171.488H71.5283C71.5465 171.757 71.6234 171.98 71.7588 172.16C71.8968 172.337 72.0804 172.471 72.3096 172.562C72.5413 172.651 72.8031 172.695 73.0947 172.695C73.3812 172.695 73.6299 172.654 73.8408 172.57C74.0544 172.487 74.2197 172.371 74.3369 172.223C74.4541 172.074 74.5127 171.904 74.5127 171.711C74.5127 171.531 74.4593 171.38 74.3525 171.258C74.2484 171.135 74.0947 171.031 73.8916 170.945C73.6911 170.859 73.445 170.781 73.1533 170.711L72.2822 170.492C71.6077 170.328 71.0752 170.072 70.6846 169.723C70.2939 169.374 70.0999 168.904 70.1025 168.312C70.0999 167.828 70.2288 167.405 70.4893 167.043C70.7523 166.681 71.113 166.398 71.5713 166.195C72.0296 165.992 72.5505 165.891 73.1338 165.891C73.7275 165.891 74.2458 165.992 74.6885 166.195C75.1338 166.398 75.4801 166.681 75.7275 167.043C75.9749 167.405 76.1025 167.824 76.1104 168.301H74.4893ZM77.3574 174V166H80.5137C81.1204 166 81.6374 166.116 82.0645 166.348C82.4915 166.577 82.8171 166.896 83.041 167.305C83.2676 167.711 83.3809 168.18 83.3809 168.711C83.3809 169.242 83.2663 169.711 83.0371 170.117C82.8079 170.523 82.4759 170.84 82.041 171.066C81.6087 171.293 81.0853 171.406 80.4707 171.406H78.459V170.051H80.1973C80.5228 170.051 80.791 169.995 81.002 169.883C81.2155 169.768 81.3743 169.611 81.4785 169.41C81.5853 169.207 81.6387 168.974 81.6387 168.711C81.6387 168.445 81.5853 168.214 81.4785 168.016C81.3743 167.815 81.2155 167.66 81.002 167.551C80.7884 167.439 80.5176 167.383 80.1895 167.383H79.0488V174H77.3574ZM91.8311 170C91.8311 170.872 91.6657 171.615 91.335 172.227C91.0068 172.839 90.5589 173.306 89.9912 173.629C89.4261 173.949 88.7907 174.109 88.085 174.109C87.374 174.109 86.736 173.948 86.1709 173.625C85.6058 173.302 85.1592 172.835 84.8311 172.223C84.5029 171.611 84.3389 170.87 84.3389 170C84.3389 169.128 84.5029 168.385 84.8311 167.773C85.1592 167.161 85.6058 166.695 86.1709 166.375C86.736 166.052 87.374 165.891 88.085 165.891C88.7907 165.891 89.4261 166.052 89.9912 166.375C90.5589 166.695 91.0068 167.161 91.335 167.773C91.6657 168.385 91.8311 169.128 91.8311 170ZM90.1162 170C90.1162 169.435 90.0316 168.958 89.8623 168.57C89.6956 168.182 89.46 167.888 89.1553 167.688C88.8506 167.487 88.4938 167.387 88.085 167.387C87.6761 167.387 87.3193 167.487 87.0146 167.688C86.71 167.888 86.473 168.182 86.3037 168.57C86.137 168.958 86.0537 169.435 86.0537 170C86.0537 170.565 86.137 171.042 86.3037 171.43C86.473 171.818 86.71 172.112 87.0146 172.312C87.3193 172.513 87.6761 172.613 88.085 172.613C88.4938 172.613 88.8506 172.513 89.1553 172.312C89.46 172.112 89.6956 171.818 89.8623 171.43C90.0316 171.042 90.1162 170.565 90.1162 170ZM99.7754 166V174H98.3145L94.834 168.965H94.7754V174H93.084V166H94.5684L98.0215 171.031H98.0918V166H99.7754ZM104.009 174H101.173V166H104.032C104.837 166 105.53 166.16 106.11 166.48C106.691 166.798 107.138 167.255 107.45 167.852C107.765 168.448 107.923 169.161 107.923 169.992C107.923 170.826 107.765 171.542 107.45 172.141C107.138 172.74 106.688 173.199 106.103 173.52C105.519 173.84 104.821 174 104.009 174ZM102.864 172.551H103.938C104.438 172.551 104.859 172.462 105.2 172.285C105.544 172.105 105.802 171.828 105.974 171.453C106.148 171.076 106.235 170.589 106.235 169.992C106.235 169.401 106.148 168.918 105.974 168.543C105.802 168.168 105.545 167.892 105.204 167.715C104.863 167.538 104.442 167.449 103.942 167.449H102.864V172.551ZM109.176 174V166H114.566V167.395H110.867V169.301H114.289V170.695H110.867V172.605H114.582V174H109.176ZM115.911 174V166H119.067C119.672 166 120.187 166.108 120.614 166.324C121.044 166.538 121.371 166.841 121.595 167.234C121.821 167.625 121.935 168.085 121.935 168.613C121.935 169.145 121.82 169.602 121.591 169.984C121.362 170.365 121.03 170.656 120.595 170.859C120.162 171.062 119.639 171.164 119.024 171.164H116.911V169.805H118.751C119.074 169.805 119.342 169.76 119.556 169.672C119.769 169.583 119.928 169.451 120.032 169.273C120.139 169.096 120.192 168.876 120.192 168.613C120.192 168.348 120.139 168.124 120.032 167.941C119.928 167.759 119.768 167.621 119.552 167.527C119.338 167.431 119.069 167.383 118.743 167.383H117.603V174H115.911ZM120.231 170.359L122.22 174H120.353L118.407 170.359H120.231Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_727_9946",
    x: 0,
    y: 0,
    width: 178,
    height: 226,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_727_9946"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_727_9946"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_727_9946",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasPageQuiz);
export default __webpack_public_path__ + "static/media/canvas_page_quiz.882ffd8169e427ce81626db224bdd7fb.svg";
export { ForwardRef as ReactComponent };